import React from 'react';
import { TbMailForward } from 'react-icons/tb';
import { CommentForwardButtonContainer } from './styles';

export function CommentForwardButton({
  onClick,
  comment,
  isSelected,
  onSelect
}) {
  const handleClick = () => {
    if (onSelect) {
      onSelect(comment, !isSelected);
    }

    if (onClick) {
      onClick(!isSelected);
    }
  };

  return (
    <CommentForwardButtonContainer
      isSelected={isSelected}
      onClick={handleClick}
    >
      <TbMailForward size={14} />
      Encaminhar
    </CommentForwardButtonContainer>
  );
}
